(function () {
  const picker = document.querySelector('.vault-layer-picker');
  if (!picker) return;

  const variantSlotMap = JSON.parse(picker.dataset.variantSlotMap);
  const allSlots = [...picker.querySelectorAll('.vault-slot')];
  const validationMsg = picker.querySelector('.vault-validation-msg');

  // Use the section-specific form ID (same approach pepbox uses) to avoid matching
  // the installment form, which also has action="/cart/add" and appears first in the DOM.
  const formId = picker.dataset.productFormId;
  const form = (formId && document.getElementById(formId))
            || document.querySelector(`form[id^="product-form-"]:not([id*="installment"])`);
  if (!form) return;

  const hiddenInputs = new Map();

  function getLabel(slot) {
    return slot.querySelector('label').textContent.trim();
  }

  function upsertHiddenInput(slot) {
    const label = getLabel(slot);

    if (slot.hidden) {
      const existing = hiddenInputs.get(label);
      if (existing) { existing.remove(); hiddenInputs.delete(label); }
      return;
    }

    let input = hiddenInputs.get(label);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${label}]`;
      form.appendChild(input);
      hiddenInputs.set(label, input);
    }
    input.value = slot.querySelector('select').value;
  }

  function validate() {
    const incomplete = allSlots.filter(s => !s.hidden && s.querySelector('select').value === '');
    if (incomplete.length > 0) {
      validationMsg.hidden = false;
      validationMsg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return false;
    }
    validationMsg.hidden = true;
    return true;
  }

  function resetDropdowns() {
    allSlots.forEach(slot => {
      if (!slot.hidden) slot.querySelector('select').value = '';
      upsertHiddenInput(slot);
    });
  }

  function updateSlots(variantId) {
    const activeCount = variantSlotMap[String(variantId)] ?? 0;
    allSlots.forEach((slot, i) => {
      const wasHidden = slot.hidden;
      slot.hidden = i >= activeCount;
      if (!wasHidden && slot.hidden) slot.querySelector('select').value = '';
      upsertHiddenInput(slot);
    });
  }

  // Keep hidden inputs in sync as the user selects options
  allSlots.forEach(slot => {
    slot.querySelector('select').addEventListener('change', () => {
      upsertHiddenInput(slot);
      validationMsg.hidden = true;
    });
  });

  // Register validator so pepbox (or any other submit interceptor) can run it.
  form._pepboxValidators = form._pepboxValidators || [];
  form._pepboxValidators.push(validate);

  // Fallback submit listener for pages where pepbox is not intercepting this form.
  // When pepbox IS active it calls stopImmediatePropagation first, so this never fires —
  // validation is handled via _pepboxValidators above instead.
  form.addEventListener('submit', (e) => {
    if (!validate()) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);

  // Reset dropdowns after a successful cart add (pepbox dispatches this event)
  document.addEventListener('cart:refresh', resetDropdowns);

  // Variant change
  if (typeof subscribe === 'function') {
    subscribe('variant-change', (event) => {
      const variantId = event?.data?.variant?.id;
      if (variantId) updateSlots(variantId);
    });
  }

  // Initialise
  const initialVariantId = form.querySelector('[name="id"]')?.value;
  if (initialVariantId) updateSlots(initialVariantId);
})();
